import { autoPrintPdf, autoPrintHtml, getMacAddress, getPrintConfig, getPkgPrintConfig, getByLogistic, getDefaultLabelConfig } from '@/apis/autoPrint'
import store from '@/store'
import { templatePrintByJSON } from '@/utils/print'
import { toHtml } from '@/components/PrintTemplate/index.js'
import wmsPrint from '@/components/choosePrint/index.js'
import { autoPrintCss } from './autoPrintCss'
import { listPkgDetail } from '@/apis/outStock'
import {uploadFileApi} from '@/apis/oss'

const postNumList = [9811, 12111, 21111, 31111, 41111]

const autoPrintInt = function (postNum) {
  return new Promise(function (resolve, reject) {
    fetch(`http://127.0.0.1:${postNum}/print/getMainboardCode`, {
      method: 'get',
      headers: {
        'print-token': 'A8ED868569F32960',
        'cache-control': '',
        pragma: ''
      }
    })
      .then((res) => {
        if (res.status == '200') {
          res.json().then(function (data) {
            data.postNum = postNum
            resolve(data)
            return
          })
        } else {
          reject()
        }
      })
      .catch((res) => {
        // console.log('catch',res)
        reject()
      })
  })
}

export const wmsAutoPrintInt = function () {
  return new Promise(function (resolve, reject) {
    let arr = []
    for (let i in postNumList) {
      arr.push(autoPrintInt(postNumList[i]))
    }
    return Promise.any(arr)
      .then((res) => {
        store.dispatch('postNum/setPostNum', res.postNum)
        resolve(res)
      })
      .catch((res) => {
        store.dispatch('postNum/setPostNum', 'error')
        reject(res)
      })
  })
}

export const autoGetMac = function () {
  return new Promise(function (resolve, reject) {
    let postNum = store.getters.getPostNum.postNum
    if (!postNum) {
      wmsAutoPrintInt()
        .then((res) => {
          getMacAddress().then((mac) => {
            if (mac && mac.data) {
              // return mac;
              resolve(mac)
            } else {
              resolve({ success: false, data: null })
              // return { success: false, data: null };
            }
          })
        })
        .catch((res) => {
          console.log(res)
          // reject({ success: false, data: null });
          resolve({ success: false, data: null })
        })
    } else if (postNum == 'error') {
      resolve({ success: false, data: null })
    } else {
      getMacAddress().then((mac) => {
        if (mac && mac.data) {
          resolve(mac)
        } else {
          resolve({ success: false, data: null })
        }
      })
    }
  })
}
// pdf ['xxx','xxx']
export const printSheet = function (wmsIntForwarderConfigId, pdf) {
  return new Promise(async function (resolve, reject) {
    // if (!store.getters.getPostNum.postNum) {
    //   reject({});
    //   return;
    // }
    let mac = await autoGetMac()
    if (!mac || !mac.data) {
      reject({})
      return
    }
    getByLogistic({
      intForwarderConfigId: wmsIntForwarderConfigId,
      macAddress: mac.data
    })
      .then((res) => {
        if (res.success) {
          if (!res.data) {
            reject({})
            return
          }
          let params = pdf.map(v => ({
              url: v,
              printServiceName: res.data.printer,
              width: res.data.printPaperSizeWide,
              height: res.data.printPaperSizeHigh,
              direction: res.data.direction
          }))
          autoPrintPdf(params)
            .then((resPrint) => {
              if (resPrint.success) {
                resolve(resPrint)
                return
              }
              reject(resPrint)
            })
            .catch((resPrint) => {
              reject(resPrint)
            })
          return
        }
        reject(res)
      })
      .catch((res) => {
        reject(res)
      })
  })
}

export const printPkg = function (nodeType, systemSource, arr, fn, stationCode = '', directSaleFlag = '') {
  return new Promise(async function (resolve, reject) {
    let mac = await autoGetMac()
    if (!mac || !mac.data) {
      reject({})
      return
    }
    let params = { nodeType, systemSource, directSaleFlag }
    let pkgPrintConfig = await getPkgPrintConfig({
      ...params,
      macAddress: mac.data
    })
    if (!pkgPrintConfig || !pkgPrintConfig.data) {
      reject({})
      return
    }
    let labelConfig = await getDefaultLabelConfig({ ...params, stationCode: stationCode ? stationCode : '' })
    console.log(labelConfig)
    if (!labelConfig || !labelConfig.data) {
      reject({})
      return
    }
    if (fn) {
      labelConfig.data.templateJson = fn(labelConfig.data.templateJson)
    }
    if (nodeType == 1) {
      let nodata = []
      let printData = []
      let res = await listPkgDetail(arr.map((item) => item.pkgCode))
      function dataFormat(data, wantPrintNum) {
        return {
          ...data,
          wantPrintNum: wantPrintNum,
          additionalListNames: data.additionalList
            ?.map((v) => {
              let text = v.additionWithIngredientProp + (v.additionExtraName ? `:${v.additionExtraName}` : '')
              return text
            })
            .join(),
          additionWithIngredientGrid: data.additionalList
            ?.map((v) => {
              let text = v.additionWithIngredientGrid + (v.additionExtraName ? `:${v.additionExtraName}` : '')
              return text
            })
            .join(),
          additionOnlyNames: data.additionalList
            ?.map((v) => {
              let text = v.additionName + (v.additionExtraName ? `:${v.additionExtraName}` : '')
              return text
            })
            .join(),
          systemSource: data.systemSource == 1 ? 'D2C' : data.systemSource == 2 ? 'B2B' : `系统来源${data.systemSource}`,
          specialFlag: data.specialFlag == 1 ? '特' : '',
          ingredientsFlag: data.ingredientsFlag == 1 ? '辅' : '',
          combinationProductItemFlag: data.combinationProductItemFlag == 1 ? '组' : '',
          customerTag: data.customerTag == 1 ? '重' : data.customerTag == 2 ? '重-非' : '',
          ingredientType: data.ingredientType == 1 ? '质检辅料' : data.ingredientType == 2 ? '成品辅料' : '',
          crossDockingFlag: data.crossDockingFlag ? '越' : ''
          // productProp: cutbytestr(data.productProp, 14)
        }
      }
      arr.forEach((item, index) => {
        if (JSON.stringify(res.data[index]) === '{}' || !res.data[index].pkgCode) {
          nodata.push(item.pkgCode)
        } else {
          printData.push(dataFormat(res.data[index], item.wantPrintNum || 1))
        }
      })
      printData = mixMultiTemplateWithPkg(printData, labelConfig.data.defaultLabelConfigDetailList)
      if (nodata.length > 0 && printData.length > 0) {
        this.$confirm(`${nodata}无批次包信息，确认打印其余批次包`, '提示', {
          confirmButtonText: '确认',
          type: 'error',
          cancelButtonText: '取消'
        }).then(() => {
          toPrint(printData)
        })
      } else if (nodata.length > 0 && printData.length == 0) {
        this.$confirm(`${nodata}无批次包信息`, '提示', {
          confirmButtonText: '确认',
          type: 'error',
          cancelButtonText: '取消'
        }).then(() => {})
      } else {
        toPrint(printData)
      }
    } else {
      toPrint()
    }

    function mixMultiTemplateWithPkg(printData, defaultLabelConfigDetailList) {
      const list = []
      printData.forEach((v) => {
        defaultLabelConfigDetailList.forEach((i) => {
          console.log(v)
          list.push({
            ...v,
            wantPrintNum: v.oemProductClassificationId == 3 ? 1 : i.printQuantityBasis == 1 && i.printQuantityImport ? i.printQuantityImport : v?.wantPrintNum || 1,
            targetTemplate: i.templateJson
          })
        })
      })
      return list
    }

    function cutbytestr(str, len) {
      var str_length = 0
      var str_len = 0
      var str_cut
      str_cut = new String()
      str_len = str.length
      for (var i = 0; i < str_len; i++) {
        let a = str.charAt(i)
        str_length++
        if (escape(a).length > 4) {
          //中文字符的长度经编码之后大于4
          str_length++
        }
        str_cut = str_cut.concat(a)
        if (str_length >= len) {
          // str_cut = str_cut.concat("…");
          return str_cut
        }
      }
      //如果给定字符串小于指定长度，则返回源字符串；
      if (str_length < len) {
        return str
      }
    }

    function toPrint(printData = arr) {
      console.log(toPrint)
      let autoPrintParams = printData.map((item) => {
        console.log(printData)
        const targetTemplate = item.targetTemplate ?? labelConfig.data.templateJson
        return {
          html: toHtml(fn ? targetTemplate : JSON.parse(targetTemplate), item),
          nums: item?.wantPrintNum || 1,
          printServiceName: pkgPrintConfig.data.printer,
          width: pkgPrintConfig.data.printPaperSizeWide,
          height: pkgPrintConfig.data.printPaperSizeHigh,
          direction: pkgPrintConfig.data.direction
        }
      })
      autoPrintHtml(autoPrintParams)
        .then((resPrint) => {
          if (resPrint.success) {
            resolve(resPrint)
            return
          }
          reject(resPrint)
        })
        .catch((resPrint) => {
          reject(resPrint)
        })
    }
  })
}

export const printContainer = function (arr, fn) {
  return new Promise(async function (resolve, reject) {
    let mac = await autoGetMac()
    if (!mac || !mac.data) {
      reject({})
      return
    }
    let params = { nodeType: 3, systemSource: 0 }
    let pkgPrintConfig = await getPkgPrintConfig({
      ...params,
      macAddress: mac.data
    })
    if (!pkgPrintConfig || !pkgPrintConfig.data) {
      reject({})
      return
    }
    let labelConfig = await getDefaultLabelConfig({ ...params })
    if (!labelConfig || !labelConfig.data) {
      reject({})
      return
    }
    toPrint()

    function toPrint(printData = arr) {
      console.log(toPrint)
      let autoPrintParams = printData.map((item) => {
        console.log(printData)
        return {
          html: toHtml(JSON.parse(labelConfig.data.templateJson), item),
          nums: item?.wantPrintNum || 1,
          printServiceName: pkgPrintConfig.data.printer,
          width: pkgPrintConfig.data.printPaperSizeWide,
          height: pkgPrintConfig.data.printPaperSizeHigh,
          direction: pkgPrintConfig.data.direction
        }
      })
      autoPrintHtml(autoPrintParams)
        .then((resPrint) => {
          if (resPrint.success) {
            resolve(resPrint)
            return
          }
          reject(resPrint)
        })
        .catch((resPrint) => {
          reject(resPrint)
        })
    }
  })
}

const URLtoFile = async (url) => {
  const res = await fetch(url)
  const blob = await res.blob()
  const mime = blob.type
  const ext = mime.slice(mime.lastIndexOf('/') + 1, mime.length)
  const file = new File([blob], `filename.${ext}`, {
    type: mime
  })
  return file
}
// url合并pdf
export const margePDF = async (urls) => {
  const a = []
  for (let i = 0; i < urls.length; i++) {
    const file = await URLtoFile(urls[i])
    a.push(file)
  }
  const newPDF = await mergePDFs(a)
  return newPDF
}
async function mergePDFs(pdfFiles) {
  const PDFLib = window.PDFLib
  // 创建一个新的PDF文档
  const mergedPdfDocument = await PDFLib.PDFDocument.create()
  // 逐个加载用户选择的PDF文件
  for (const file of pdfFiles) {
    const reader = new FileReader()
    reader.onload = async function () {
      const pdfBytes = new Uint8Array(this.result)
      const pdf = await PDFLib.PDFDocument.load(pdfBytes)
      // 复制每个页面到新的PDF文档中
      const copiedPages = await mergedPdfDocument.copyPages(pdf, pdf.getPageIndices())
      copiedPages.forEach((page) => mergedPdfDocument.addPage(page))
    }
    reader.readAsArrayBuffer(file)
  }

  // 等待所有文件加载和页面复制完成
  await new Promise((resolve) => setTimeout(resolve, 1000))

  // 保存合并后的PDF文件
  const mergedPdfBytes = await mergedPdfDocument.save()
  const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' })
  console.log(blob)
  const url = URL.createObjectURL(blob)
  return { url, file: blob }
}

export const uploadFile = async (newFile) => {
  const formData = new FormData();
  formData.append("file", new File([newFile.file], new Date().getTime() + '.pdf'));
  formData.append("path", 'wmsHotPack/');

  const { data } = await uploadFileApi(formData);
  return `https://${data.customDomain}/${data.fileName}`
}